import { Box } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import type { DashboardTaskCounts } from "../types"

import { ApprovalBucketTab } from "./ApprovalBucketTab"

interface ApprovalBucketTabConfig {
  label: string
  path: string
  disabled: boolean
  testId: string
  countKey: keyof Omit<DashboardTaskCounts, "total" | "__typename">
}

const TABS: readonly ApprovalBucketTabConfig[] = [
  {
    label: "Price Approvals",
    path: "/app/dashboard/pending-approvals/price",
    disabled: false,
    testId: "price-approvals-tab",
    countKey: "priceApprovals",
  },
  {
    label: "Quality Approvals",
    path: "/app/dashboard/pending-approvals/quality",
    disabled: false,
    testId: "quality-approvals-tab",
    countKey: "qualityApprovals",
  },
  {
    label: "Source Change Approvals",
    path: "/app/dashboard/pending-approvals/source-change",
    disabled: false,
    testId: "source-change-approvals-tab",
    countKey: "sourceChangeApprovals",
  },
  {
    label: "Sample Requests",
    path: "/app/dashboard/pending-approvals/sample",
    disabled: true,
    testId: "sample-approvals-tab",
    countKey: "sampleRequests",
  },
] as const

interface ApprovalBucketTabsProps {
  taskCounts: DashboardTaskCounts
  loading?: boolean
}

export const ApprovalBucketTabs: FC<ApprovalBucketTabsProps> = ({ taskCounts, loading = false }) => {
  return (
    <Box
      className={twMerge("grid grid-cols-4 gap-4", loading && "opacity-60")}
      data-testid='dashboard.approval-bucket-tabs'
    >
      {TABS.map((tab) => (
        <ApprovalBucketTab
          key={tab.path}
          label={tab.label}
          path={tab.path}
          count={taskCounts[tab.countKey]}
          disabled={tab.disabled}
          data-testid={`dashboard.approval-bucket-tabs.${tab.testId}`}
        />
      ))}
    </Box>
  )
}
